<Modal title="查看角色" v-model="visible">
    <Form ref="roleForm" label-position="top" v-if="visible" :model="dto">
        <Tabs value="detail">
            <TabPane :label="L('RoleDetails')" name="detail">
                <FormItem :label="L('RoleName')" prop="name">
                    {{dto.name}}
                </FormItem>
                <FormItem :label="L('DisplayName')" prop="displayName">
                    {{dto.displayName}}
                </FormItem>
                <FormItem :label="L('Description')" prop="description">
                    {{dto.description}}
                </FormItem>
            </TabPane>
            <TabPane :label="L('RolePermission')" name="permission">
                <Tree :data="permissions" ref="permissionTree" show-checkbox></Tree>
            </TabPane>
            <TabPane label="关联岗位">
                <Card>
                    <table>
                        <tr v-for="position in positions" v-key="position.id">
                            <td>{{position.fullDisplayName}}</td>
                        </tr>
                    </table>
                </Card>

            </TabPane>
        </Tabs>
    </Form>
    <div slot="footer">
        <Button @click="handleCloseClick">{{L('Close')}}</Button>
    </div>
</Modal>